import { createAction } from "@reduxjs/toolkit";

export const getAllUsersAction = createAction("models/users");

export const modifyUserBalanceAction = createAction("models/users/user_id");